import * as React from 'react';

const Icon: React.FC<{ fill?: string }> = ({ fill }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38 4C41.3137 4 44 6.68629 44 10V38C44 41.3137 41.3137 44 38 44H10C9.96055 44 9.92119 43.9996 9.88192 43.9989L9.88194 43.9965L9.64745 43.9898C6.49784 43.8073 4 41.1954 4 38V10C4 6.68629 6.68629 4 10 4H38ZM32 22.83L14.828 40H38C39.0257 40 39.871 39.2279 39.9865 38.2332L40 38V30.83L32 22.83ZM38 8H10C8.89543 8 8 8.89543 8 10V38C8 38.8578 8.54006 39.5895 9.29871 39.8736L30.5858 18.5858C31.3068 17.8648 32.4412 17.8094 33.2258 18.4194L33.4142 18.5858L40 25.17V10C40 8.97433 39.2279 8.12899 38.2332 8.01346L38 8ZM17 12C19.7614 12 22 14.2386 22 17C22 19.7614 19.7614 22 17 22C14.2386 22 12 19.7614 12 17C12 14.2386 14.2386 12 17 12ZM17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16Z"
          fill={fill || 'white'}
        />
      </g>
    </svg>
  );
};

export default Icon;
